import cp = require('child_process');
import Uri from 'vscode-uri';
import path = require('path');
import { getBinPath, byteOffsetAt, canonicalizeGOPATHPrefix, getFileArchive,
    getToolsEnvVars, Position, Location, Range } from './util';
import { TextDocument } from '@workbench-stack/language-core';


export class GoReferenceProvider {

    public provideReferences(document: TextDocument, position: Position, options: { includeDeclaration: boolean }): Thenable<Location[]> {
        return this.doFindReferences(document, position, options);
    }

    private doFindReferences(document: TextDocument, position: Position, options: { includeDeclaration: boolean }): Thenable<Location[]> {
        return new Promise<Location[]>((resolve, reject) => {
            // get current word
            let wordRange = document.getWordRangeAtPosition(position);
            if (!wordRange) {
                return resolve([]);
            }

            let goGuru = getBinPath('guru');
            if (!path.isAbsolute(goGuru)) {
                return reject('Cannot find tool "guru" to find references.');
            }

            let filename = canonicalizeGOPATHPrefix(document.fileName);
            let cwd = path.dirname(filename);
            let offset = byteOffsetAt(document, position);
            let env = getToolsEnvVars();
            let args = [];
            args.push('-modified', 'referrers', `${filename}:#${offset.toString()}`);

            let process = cp.execFile(goGuru, args, { env }, (err, stdout, stderr) => {
                try {
                    if (err && (<any>err).code === 'ENOENT') {
                        console.log('Cannot find tool "guru" to find references.');
                        return reject('Cannot find tool "guru" to find references.');
                    }

                    if (err && (<any>err).killed !== true) {
                        console.log(`Error running guru: ${err.message || stderr}`);
                        return reject(`Error running guru: ${err.message || stderr}`);
                    }

                    let lines = stdout.toString().split('\n');
                    let results: Location[] = [];
                    for (let i = 0; i < lines.length; i++) {
                        let match = /^(.*):(\d+)\.(\d+)-(\d+)\.(\d+):/.exec(lines[i]);
                        if (!match) { continue; }
                        let [_, file, lineStartStr, colStartStr, lineEndStr, colEndStr] = match;
                        let referenceResource = Uri.file(path.resolve(cwd, file));

                        if (!options.includeDeclaration) {
                            if (document.uri.fsPath === referenceResource.fsPath &&
                                position.line === Number(lineStartStr) - 1) {
                                continue;
                            }
                        }

                        let range = new Range(
                            +lineStartStr - 1, +colStartStr - 1, +lineEndStr - 1, +colEndStr,
                        );
                        results.push(new Location(referenceResource, range));
                    }
                    resolve(results);
                } catch (e) {
                    console.log('e', e);
                    reject(e);
                }
            });
            process.stdin.end(getFileArchive(document));

        });
    }

}
